







































































import { Vue, Component, Prop } from "vue-property-decorator";
import { bus } from "../../main";
import ConvenzioneTirEstivoReview from "../ReviewDoc/ConvenzioneTirEstivoReview.vue";
import ProgettoOrientamentoTirEstivoReview from "../ReviewDoc/ProgettoOrientamentoTirEstivoReview.vue";
import ConsensoReview from "../ReviewDoc/ConsensoReview.vue";
import ConvenzioneTirFormativoReview from "../ReviewDoc/ConvenzioneTirFormativoReview.vue";
import AttestatoFinaleTirEstivoReview from "../ReviewDoc/AttestatoFinaleTirEstivoReview.vue";
import AttestatoFinaleAlternanzaReview from "../ReviewDoc/AttestatoFinaleAlternanzaReview.vue";
import { DocConvenzione } from "../../_models/docConvenzione";
import { DocProgettoOrientamento } from "../../_models/docProgettoOrientamento";
import { DocConsenso } from "../../_models/docConsenso";
import { DocAttestatoFinale } from "../../_models/docAttestatoFinale";
import { DocPattoFormativo } from "../../_models/docPattoFormativo";
import { DocPercorsoFormativo } from "../../_models/docPercorsoFormativo";
import QuestionarioReview from "../ReviewDoc/QuestionarioReview.vue";
import ConvenzioneAlternanzaReview from "../ReviewDoc/ConvenzioneAlternanzaReview.vue";
import PattoFormativoAlternanzaReview from "../ReviewDoc/PattoFormativoAlternanzaReview.vue";
import PercorsoFormativoAlternanzaReview from "../ReviewDoc/PercorsoFormativoAlternanzaReview.vue";
import ConvenzioneTirReInsReview from "../ReviewDoc/ConvenzioneTirReInsReview.vue";
import FoglioFirmeReview from "../ReviewDoc/FoglioFirmeReview.vue";
import IspezioneReview  from "../ReviewDoc/IspezioneReview.vue";
import DocDVRReview from "../ReviewDoc/DocDVRReview.vue";

@Component({
  components: {
    ConvenzioneTirEstivoReview,
    ProgettoOrientamentoTirEstivoReview,
    ConsensoReview,
    ConvenzioneTirFormativoReview,
    AttestatoFinaleTirEstivoReview,
    AttestatoFinaleAlternanzaReview,
    QuestionarioReview,
    ConvenzioneAlternanzaReview,
    PattoFormativoAlternanzaReview,
    PercorsoFormativoAlternanzaReview,
    ConvenzioneTirReInsReview,
    FoglioFirmeReview,
    IspezioneReview,
    DocDVRReview
  }
})
export default class DocReviewDialog extends Vue {
  @Prop() docType!: string;
  //   @Prop() docInfo!: any;   modifica temporanea per testsre passaggio di dati tra componenti

  private docConvenzioneElements: DocConvenzione;
  private docProgettoOrientamento: DocProgettoOrientamento;
  private docConsenso: DocConsenso;
  private docPattoFormativo: DocPattoFormativo;
  private docPercorsoFormativo: DocPercorsoFormativo;
  private docAttestatoFinale: DocAttestatoFinale;
  private docQuestionario: any; //any perche' dinamico
  private docFoglioFirme: any; //any perchè dinamico
  private docIspezione: any;
  private docReviewDialog: boolean;
  private activityType: string;
  private docDVR: any;
  private emailAzienda: string;

  constructor() {
    super();
    this.activityType = "";
    this.docReviewDialog = false;
    this.docConvenzioneElements = {
      idConvenzione: 0,
      denominazioneIstituto: "",
      indirizzoIstituto: "",
      capIstituto: "",
      comuneIstituto: "",
      provinciaIstituto: "",
      telefonoIstituto: "",
      emailIstituto: "",
      codiceFiscaleIstituto: "",
      dirigenteIstituto: "",
      luogoNascitaDirigenteIstituto: "",
      dataNascitaDirigenteIstituto: "",
      denominazioneAzienda: "",
      indirizzoAzienda: "",
      capAzienda: "",
      comuneAzienda: "",
      provinciaAzienda: "",
      telefonoAzienda: "",
      emailAzienda: "",
      pecAzienda: "",
      pIvaAzienda: "",
      rappresentanteAzienda: "",
      luogoNascitaRappresentanteAzienda: "",
      dataNascitaRappresentante: "",
      dataDocumento: "",
      idStatoDoc: 0,
      firmaAzienda: "",
      firmaIstituto: "",
      tipoAttivita: "",
      numeroProtocollo: "",
      idTemplate: 0,
      codAteco: "",
      codIstat: "",
      indirizzoTirocinio: "",
      comuneTirocinio: "",
      provinciaTirocinio: "",
      tutorAziendale: "",
      tutorFormativo: ""
    };
    this.docProgettoOrientamento = {
      idProgettoOrientamento: 0,
      denominazioneIstituto: "",
      indirizzoIstituto: "",
      capIstituto: "",
      comuneIstituto: "",
      provinciaIstituto: "",
      telefonoIstituto: "",
      emailIstituto: "",
      pecIstituto: "",
      codiceFiscaleIstituto: "",
      dirigenteIstituto: "",
      luogoNascitaDirigenteIstituto: "",
      dataNascitaDirigenteIstituto: "",
      tutorFormativo: "",
      denominazioneAzienda: "",
      indirizzoAzienda: "",
      capAzienda: "",
      comuneAzienda: "",
      provinciaAzienda: "",
      telefonoAzienda: "",
      emailAzienda: "",
      pecAzienda: "",
      pIvaAzienda: "",
      indirizzoTirocinio: "",
      comuneTirocinio: "",
      provinciaTirocinio: "",
      codAteco: "",
      descrizioneAteco: "",
      codIstat: "",
      descrizioneIstat: "",
      rappresentanteAzienda: "",
      luogoNascitaRappresentante: "",
      dataNascitaRappresentante: "",
      tutorAziendale: "",
      tirocinante: "",
      dataNascitaTirocinante: "",
      luogoNascitaTirocinante: "",
      indirizzoTirocinante: "",
      comuneTirocinante: "",
      provinciaTirocinante: "",
      telefonoTirocinante: "",
      emailTirocinante: "",
      codiceFiscaleTirocinante: "",
      classeTirocinante: "",
      durataTirocinio: "",
      dataInizioPeriodo: "",
      dataFinePeriodo: "",
      orarioInizioMattino: "",
      orarioFineMattino: "",
      orarioInizioPomeriggio: "",
      orarioFinePomeriggio: "",
      usoFuoriSede: "",
      posizioneINAIL: "",
      numeroPolizzaAssicurativa: "",
      assicurazione: "",
      facilitazione: "",
      attivitaTirocinio: "",
      dataDocumento: "",
      idStatoDoc: 0,
      firmaAzienda: "",
      firmaTirocinante: "",
      firmaAziendaDue: "",
      firmaTirocinanteDue: "",
      firmaEsercentePatriaPotesta: "",
      firmaIstituto: "",
      capTirocinio: "",
      tipoAttivita: "",
      numeroProtocollo: "",
      idTemplate: 0
    };
    this.docConsenso = {
      idConsenso: 0,
      rappresentanteAzienda: "",
      denominazioneAzienda: "",
      pIvaAzienda: "",
      comuneAzienda: "",
      indirizzoAzienda: "",
      tirocinante: "",
      indirizzoTirocinante: "",
      comuneTirocinante: "",
      dataDocumento: "",
      idStatoDoc: 0,
      firmaAzienda: "",
      firmaTirocinante: "",
      firmaIstituto: "",
      tipoAttivita: "",
      numeroProtocollo: "",
      idTemplate: 0
    };
    this.docAttestatoFinale = {
      idAttestatoFinale: 0,
      dataAttestato: "",
      luogoAttestato: "",
      dataInizioPeriodo: "",
      dataFinePeriodo: "",
      totaleOre: 0,
      denominazioneAzienda: "",
      allievo: "",
      classeAllievo: "",
      noteAggiuntive: "",
      gruppoUno: 0,
      gruppoDue: 0,
      gruppoTre: 0,
      gruppoQuattro: 0,
      gruppoCinque: 0,
      gruppoSei: 0,
      gruppoSette: 0,
      gruppoOtto: 0,
      gruppoNove: 0,
      gruppoDieci: 0,
      firmaTutorAzienda: "",
      tipoAttivita: "",
      idRichiesta: 0,
      numeroProtocollo: "",
      dataProtocollo: "",
      idTutorAzienda: 0,
      tutorAzienda: "",
      tutorFormativo: ""
    };
    this.docPattoFormativo = {
      idPattoFormativo: 0,
      idRichiesta: 0,
      denominazioneIstituto: "",
      cognomeAllievo: "",
      nomeAllievo: "",
      codiceFiscaleAllievo: "",
      luogoNascitaAllievo: "",
      dataNascitaAllievo: "",
      indirizzoAllievo: "",
      comuneAllievo: "",
      provinciaAllievo: "",
      capAllievo: "",
      telefonoAllievo: "",
      emailAllievo: "",
      classe: "",
      cognomeTutore: "",
      nomeTutore: "",
      relazioneParentale: "",
      telefonoTutore: "",
      indirizzoTutore: "",
      comuneTutore: "",
      provinciaTutore: "",
      capTutore: "",
      statoDocumento: "",
      firmaAllievo: "",
      firmaTutore: "",
      dataDocumento: "",
      paeseNascitaAllievo: "",
      denominazioneAzienda: "",
      indirizzoAzienda: "",
      capAzienda: "",
      comuneAzienda: "",
      provinciaAzienda: "",
      telefonoAzienda: "",
      emailAzienda: "",
      emailPecAzienda: "",
      pIvaAzienda: "",
      indirizzoTirocinio: "",
      comuneTirocinio: "",
      provinciaTirocinio: "",
      dataInizioPeriodo: "",
      dataFinePeriodo: "",
      idTipoAttivita: 0,
      idTemplate: 0,
      firmaIstituto: ""
    };
    this.docPercorsoFormativo = {
      idPercorsoFormativo: 0,
      idRichiesta: 0,
      denominazioneIstituto: "",
      denominazioneAzienda: "",
      comuneIstituto: "",
      tutorFormativo: "",
      emailTutorFormativo: "",
      tutorAziendale: "",
      emailTutorAziendale: "",
      indirizzoTirocinio: "",
      capTirocinio: "",
      comuneTirocinio: "",
      provinciaTirocinio: "",
      tirocinante: "",
      dataNascitaTirocinante: "",
      luogoNascitaTirocinante: "",
      indirizzoTirocinante: "",
      comuneTirocinante: "",
      provinciaTirocinante: "",
      telefonoTirocinante: "",
      emailTirocinante: "",
      codiceFiscaleTirocinante: "",
      classeTirocinante: "",
      durataTirocinio: "",
      dataInizioPeriodo: "",
      dataFinePeriodo: "",
      orarioInizioMattino: "",
      orarioFineMattino: "",
      orarioInizioPomeriggio: "",
      orarioFinePomeriggio: "",
      usoFuoriSede: "",
      attivitaTirocinio: "",
      posizioneInail: "",
      numeroPolizzaAssicurativa: "",
      assicurazione: "",
      dataDocumento: "",
      idStatoDocumento: 0,
      firmaAzienda: "",
      firmaTirocinante: "",
      firmaTutore: "",
      idTipoAttivita: 0,
      numeroProtocollo: "",
      idTemplate: 0,
      tutore: "",
      rappresentanteAzienda: "",
      pivaAzienda: "",
      comuneAzienda: "",
      provinciaAzienda: "",
      indirizzoAzienda: "",
      firmaIstituto: "",
      firmaAziendaDue: ""
    };
    this.docQuestionario = {};
    this.docFoglioFirme = {};
    this.docIspezione = {};
    this.docDVR = {};
    this.emailAzienda = "";
  }

  created() {
    //@ts-ignore
    bus.$on("openDocConvenzioneReview", payload => {
      this.docConvenzioneElements = payload;
      this.activityType = payload.tipoAttivita;
      this.docReviewDialog = true;
    });

    //@ts-ignore
    bus.$on("openDocProgettoOrientamentoReview", payload => {
      this.docProgettoOrientamento = payload;
      this.activityType = payload.tipoAttivita;
      this.docReviewDialog = true;
    });

    //@ts-ignore
    bus.$on("openDocConsensoReview", payload => {
      this.docConsenso = payload;
      this.activityType = payload.tipoAttivita;
      this.docReviewDialog = true;
    });

    //@ts-ignore
    bus.$on("openDocAttestatoFinaleReview", payload => {
      this.docAttestatoFinale = payload;
      this.docReviewDialog = true;
    });

    //@ts-ignore
    bus.$on("openDocAttestatoFinaleAlternanzaReview", payload => {
      this.docAttestatoFinale = payload;
      this.docReviewDialog = true;
    });

    //@ts-ignore
    bus.$on("openDocQuestionarioReview", payload => {
      this.docQuestionario = payload;
      this.docReviewDialog = true;
    });

    //@ts-ignore
    bus.$on("openDocPattoFormativoReview", payload => {
      this.docPattoFormativo = payload;
      this.activityType = "alternanza";
      this.docReviewDialog = true;
    });

    //@ts-ignore
    bus.$on("openDocPercorsoFormativoReview", payload => {
      this.docPercorsoFormativo = payload;
      this.activityType = "alternanza";
      this.docReviewDialog = true;
    });

    //@ts-ignore
    bus.$on("openDocFoglioFirmeReview", payload => {
      this.docFoglioFirme = payload;
      this.docReviewDialog = true;
    });

    //@ts-ignore
    bus.$on("openDocDVRReview", (docDVR, info) => {
      this.docDVR = docDVR;
      this.emailAzienda = info.emailAzienda;
      this.docReviewDialog = true;
    });

    //@ts-ignore
    bus.$on("openDocIspezioneReview", payload => {
      this.docIspezione = payload;
      this.docReviewDialog = true;
    });

    bus.$on("closeDocReviewDialog", () => {
      this.docReviewDialog = false;
    });

    bus.$on("closeReview", () => {
      this.docReviewDialog = false;
      bus.$emit("refreshDocs");
    });
  }

  async close() {
    bus.$emit("closeDocReview");
    if (this.docType === "questionarioWorkshopAzienda") {
      bus.$emit("closeActivityDialog");
    }

    // bus.$emit("destroyDocReviewDialog")
  }
}
